var installedModules = {};
var moduleToHandlerMapping = {
	98670: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Observable_js"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_resource_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_rxjs_dist_esm_internal_BehaviorSubject_js-node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	8220: {
		getter: () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	75156: {
		getter: () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	29569: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_lodash_lodash_js-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs"), __webpack_require__.e("default-node_modules_luxon_build_es6_luxon_mjs"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router2_mjs"), __webpack_require__.e("default-libs_core_src_index_ts")]).then(() => (() => (__webpack_require__(/*! core */ 22763))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "core",
	},
	98161: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_lodash_lodash_js-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs"), __webpack_require__.e("default-node_modules_luxon_build_es6_luxon_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_fromEvent_js-node_modules_angular_mate-8ab4c3"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_progress-spinner_mjs"), __webpack_require__.e("default-libs_uikit_src_index_ts")]).then(() => (() => (__webpack_require__(/*! uikit */ 27320))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uikit",
	},
	75868: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	15918: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	68766: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_resource_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_rxjs-interop_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	94394: {
		getter: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_animations_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	50929: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_lodash_lodash_js-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_fromEvent_js-node_modules_angular_mate-8ab4c3"), __webpack_require__.e("default-libs_dynamic_src_index_ts")]).then(() => (() => (__webpack_require__(/*! dynamic */ 72219))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dynamic",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		98670
	],
	"default-node_modules_rxjs_dist_esm_internal_BehaviorSubject_js-node_modules_rxjs_dist_esm_int-c6ec82": [
		8220,
		75156
	],
	"default-webpack_sharing_consume_default_core_core": [
		29569
	],
	"default-webpack_sharing_consume_default_uikit_uikit-node_modules_angular_router_fesm2022_rout-c3f446": [
		98161
	],
	"default-node_modules_angular_core_fesm2022_resource_mjs": [
		75868,
		15918
	],
	"default-node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs": [
		68766
	],
	"default-libs_uikit_src_index_ts": [
		94394
	],
	"apps_room_checkout_src_app_payment-result_payment-result_component_ts": [
		50929
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}